














import Vue from 'vue'
import XAuthorizations, {
  AllowedPredicate,
} from '@/components/atoms/Auth/XAuthorizations.vue'
import PartnerItem, { PartnerItemProps } from './PartnerItem.vue'
import { Feature, MemberType, Partner } from '@/types/generated/graphql'
import myPartnersQuery from '@/graphql/user/myPartners.gql'
import { mapGetters } from 'vuex'

type PartnerItem = PartnerItemProps & {
  memberType: MemberType
  feature?: Feature
}

type Data = {
  partnerId?: string
  items: PartnerItem[]
}

type Methods = {
  fetch: () => Promise<Partner>
  authorizedItems: (allowed: AllowedPredicate) => PartnerItem[]
}

type Computed = {
  authorizedTo: (memberType: MemberType) => boolean
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: 'Partner',
  components: { XAuthorizations, PartnerItem },
  data() {
    return {
      items: [],
    }
  },
  async created() {
    const partner = await this.fetch()
    this.items = [
      {
        title: this.$tc('partnerinfo.title'),
        icon: { name: 'store', type: 'custom' },
        routeName: 'PartnerInfo',
        routeParam: { partnerId: partner.partnerId },
        memberType: MemberType.Owner,
      },
      {
        title: this.$tc('partnerShippingAddressList.title'),
        icon: { name: 'partner-address', type: 'custom' },
        routeName: 'PartnerShippingAddressList',
        routeParam: { partnerId: partner.partnerId },
        memberType: MemberType.StoreOwner,
      },
      {
        title: this.$tc('partnerAgentDestinationList.title'),
        icon: { name: 'user-address', type: 'custom' },
        routeName: 'PartnerAgentDestinationList',
        routeParam: { partnerId: partner.partnerId },
        memberType: MemberType.StoreOwner,
      },
      {
        title: this.$tc('partnerStoreOwnerList.title'),
        icon: { name: 'store-owner', type: 'custom' },
        routeName: 'PartnerStoreOwnerList',
        routeParam: { partnerId: partner.partnerId },
        memberType: MemberType.Owner,
      },
      {
        title: this.$tc('partnerBankAccountList.title'),
        icon: { name: 'bank', type: 'custom' },
        routeName: 'PartnerBankAccountList',
        routeParam: { partnerId: partner.partnerId },
        memberType: MemberType.StoreOwner,
        feature: Feature.BankAccount,
      },
    ]
  },
  computed: {
    ...mapGetters('auth', ['authorizedTo']),
  },
  methods: {
    authorizedItems(allowed: AllowedPredicate) {
      return this.items.filter(
        (item) => this.authorizedTo(item.memberType) && allowed(item.feature)
      )
    },
    async fetch() {
      const { data } = await this.$apollo.query({
        query: myPartnersQuery,
      })
      // FIXME 所属しているパートナーは1件の前提
      return data.myPartners[0]
    },
  },
})
